import React, { useState } from "react";
import {
  Modal,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
} from "@mui/material";
import NotAllDayForm from "./not-all-day";
import AllDay from "./all-day";
import Fade from "@mui/material/Fade";
import StyledCalendarModal from "./styles";

const CalendarModal = ({
  open,
  deleteButton,
  onClose,
  onCancel,
  onTitleChange,
  event,
  onStartTimeChange,
  onEndTimeChange,
  onSingleDayChange,
  onSave,
  onFullDayStartDateChange,
  onFullDayEndDateChange,
  onDelete,
}) => {
  const [isAllDay, setIsAllDay] = useState(false);

  const onChangeCheckboxHandler = (e) => {
    setIsAllDay((p) => !p);
  };

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Fade in={open} timeout={700}>
        <StyledCalendarModal>
          <div className="calendar-modal">
            <div className="modal-content">
              <div className="modal-content-cont">
                <div>
                  <Typography
                    variant="h5"
                    fontWeight={500}
                    sx={{ marginBottom: "1rem" }}
                  >
                    Evento
                  </Typography>
                  <div className="modal-event-title">
                    <TextField
                      id="outlined-basic"
                      label="Titulo"
                      variant="outlined"
                      fullWidth={true}
                      value={event?.title}
                      onChange={onTitleChange}
                    />
                  </div>
                  <div className="is-full-day-checkbox">
                    <FormControlLabel
                      onClick={onChangeCheckboxHandler}
                      control={<Checkbox checked={isAllDay} />}
                      label="Todo el día"
                    />
                  </div>

                  <div>
                    {isAllDay ? (
                      <AllDay
                        startDate={event?.start}
                        endDate={event?.end}
                        onStartDateChange={onFullDayStartDateChange}
                        onEndDateChange={onFullDayEndDateChange}
                      />
                    ) : (
                      <NotAllDayForm
                        startDate={event?.start}
                        endDate={event?.end}
                        onStartTimeChange={onStartTimeChange}
                        onEndTimeChange={onEndTimeChange}
                        onSingleDayChange={onSingleDayChange}
                      />
                    )}
                  </div>
                </div>

                <div className="calendar-modal-button-conatiner">
                  <div className="calendar-modal-buttons">
                    <Button variant="contained" size="large" onClick={onSave}>
                      Guardar
                    </Button>
                    <Button variant="outlined" size="large" onClick={onCancel}>
                      Cancelar
                    </Button>
                  </div>

                  {deleteButton && (
                    <Button
                      variant="outlined"
                      size="large"
                      onClick={() => onDelete(event)}
                    >
                      Eliminar
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </StyledCalendarModal>
      </Fade>
    </Modal>
  );
};

export default CalendarModal;
